<template>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>{{ labels.countryCode }}</label>
        <select
          v-model="address.countryCode"
          :name="`${name}-countryCode`"
          :class="{ 'is-invalid': errors.has(`${name}-countryCode}`) }"
          :data-vv-as="labels.countryCode"
          :disabled = "isDisabled"
          class="form-control"
          @change="input"
          @blur="blur"
        >
          <option value="">Select {{ labels.countryCode }}</option>
          <option
            v-for="(countryName, countryCode) in countries"
            :key="countryName"
            :value="countryCode"
          >
            {{ countryName }}
          </option>
        </select>
        <div
          v-if="errors.has(`${name}-countryCode`)"
          class="invalid-feedback">
          {{ errors.first(`${name}-countryCode`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    address: {
      type: Object,
      default: Object
    },
    countries: {
      type: Object,
      default: () => {}
    },
    labels: {
      type: Object,
      default: Object
    },
    name: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input () {
      this.$emit('updateCountryCode', this.address.countryCode)
    },
    blur () {
      this.$emit('blur')
    }
  }
}
</script>
